import './wasm'; // kickoff async wasm loading

import firebase from 'firebase/app';
import 'firebase/analytics';
import firebaseConfig from './firebase.config.json';

firebase.initializeApp(firebaseConfig);
firebase.analytics();

import Vue from 'vue';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
